import { nextTick } from "vue";
import { GetQueryString, GetUrlParam, isWechat } from "@/utils/tool";
import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
const routes = [
  // {
  //   path: "/",
  //   redirect: '/H5',
  // },
  {
    path: "/",
    name: "icp",
    component: () => import("../views/icp.vue"),
  },
  {
    path: "/H5",
    name: "getopenid",
    meta: {
      title: "",
    },
    component: () => import("../views/getopenid.vue"),
  },
  // 带下载功能的登录页
  {
    path: "/H5/login",
    name: "login",
    meta: {
      title: "",
    },
    component: () => import("../views/login.vue"),
  },
  // 登录页
  {
    path: "/H5/loginNew",
    name: "loginNew",
    meta: {
      title: "",
    },
    component: () => import("../views/loginNew.vue"),
  },
  {
    path: "/H5/real",
    name: "real",
    meta: {
      title: "",
    },
    component: () => import("../views/real.vue"),
  },
  {
    path: "/H5/htmlPay",
    name: "htmlPay",
    meta: {
      title: "",
    },
    component: () => import("../views/htmlPay.vue"),
  },
  {
    path: "/H5/htmlPayQRCode",
    name: "htmlPayQRCode",
    meta: {
      title: "",
    },
    component: () => import("../views/htmlPayQRCode.vue"),
  },
  {
    path: "/H5/newHtmlPay",
    name: "newHtmlPay",
    meta: {
      title: "",
    },
    component: () => import("../views/newHtmlPay.vue"),
  },
  {
    path: "/H5/newPcPay",
    name: "newPcPay",
    meta: {
      title: "",
    },
    component: () => import("../views/newPcPay.vue"),
  },
  {
    path: "/H5/newVipPay",
    name: "newVipPay",
    meta: {
      title: "",
    },
    component: () => import("../views/newVipPay.vue"),
  },
  {
    path: "/H5/appPay",
    name: "appPay",
    meta: {
      title: "",
    },
    component: () => import("../views/appPay.vue"),
  },
  {
    path: "/H5/shareDownload",
    name: "shareDownload",//游戏下载页面
    meta: {
      title: "",
    },
    component: () => import("../views/shareDownload.vue"),
  },
  {
    path: "/H5/official",
    name: "official",//官网下载页面
    meta: {
      title: "",
    },
    component: () => import("../views/official.vue"),
  },
  {
    path: "/htmlGame",
    name: "getopenidVersion1",
    meta: {
      title: "",
    },
    component: () => import("../views/getopenidVersion1.vue"),
  },
  {
    path: "/H5/payDetil",
    name: "payDetil",
    meta: {
      title: "",
    },
    component: () => import("../views/payDetil.vue"),
  },
  {
    path: "/H5/pay",
    name: "pay",
    meta: {
      title: "",
    },
    component: () => import("../views/pay.vue"),
  },
  {
    path: "/H5/complaint",
    name: "complaint",
    meta: {
      title: "投诉",
    },
    component: () => import("../views/complaint.vue"),
  },
  {
    path: "/H5/game",
    name: "dialog",
    meta: {
      title: "",
    },
    component: () => import("../views/dialog.vue"),
  },
  {
    path: "/H5/home",
    name: "home",
    meta: {
      title: "",
    },
    component: () => import("../views/home.vue"),
  },
  {
    path: "/H5/charge",
    name: "charge",
    meta: {
      title: "",
    },
    component: () => import("../views/chongzhi.vue"),
  },
  {
    path: "/H5/fuli",
    name: "fuli",
    meta: {
      title: "",
    },
    component: () => import("../views/fulis.vue"),
  },
  {
    path: "/H5/fulis_center",
    name: "fulis_center",
    meta: {
      title: "嗨游福利中心",
    },
    component: () => import("../views/fulis_center.vue"),
  },
  {
    path: "/H5/mine",
    name: "mine",
    meta: {
      title: "",
    },
    component: () => import("../views/mine.vue"),
  },
  {
    path: "/H5/search",
    name: "search",
    meta: {
      title: "",
    },
    component: () => import("../views/homeSearch.vue"),
  },
  {
    path: "/H5/bangding",
    name: "bangding",
    meta: {
      title: "",
    },
    component: () => import("../views/bangding.vue"),
  },
  {
    path: "/H5/homeOpen",
    name: "homeOpen",
    meta: {
      title: "",
    },
    component: () => import("../views/homeOpen.vue"),
  },
  {
    path: "/H5/vipDetil",
    name: "vipDetil",
    meta: {
      title: "",
    },
    component: () => import("../views/vipDetil.vue"),
  },
  {
    path: "/H5/platformMoney",
    name: "platformMoney",
    meta: {
      title: "",
    },
    component: () => import("../views/platformMoney.vue"),
  },
  {
    path: "/H5/backpack",
    name: "backpack",
    meta: {
      title: "卡券背包",
    },
    component: () => import("../views/backpack.vue"),
  },
  {
    path: "/H5/setUp",
    name: "setUp",
    meta: {
      title: "设置",
    },
    component: () => import("../views/setUp.vue"),
  },
  {
    path: "/H5/turntable",
    name: "turntable",
    meta: {
      title: "幸运大转盘",
    },
    component: () => import("../views/turntable.vue"),
  },
  {
    path: "/H5/winning_record",
    name: "winning_record",
    meta: {
      title: "中奖记录",
    },
    component: () => import("../views/winning_record.vue"),
  },
  {
    path: "/H5/anniversary",
    name: "anniversary",
    meta: {
      title: "周年庆",
    },
    component: () => import("../views/anniversary.vue"),
  },
  {
    path: "/H5/newFirstPay",
    name: "newFirstPay",
    meta: {
      title: "",
    },
    component: () => import("../views/newFirstPay.vue"),
  },
  {
    path: "/H5/nationalDay",
    name: "nationalDay",
    meta: {
      title: "狂欢双节",
    },
    component: () => import("../views/nationalDay.vue"),
  },
  {
    path: "/H5/newDayPay",
    name: "newDayPay",
    meta: {
      title: "",
    },
    component: () => import("../views/newDayPay.vue"),
  },
  {
    path: "/H5/goGame",
    name: "goGame",
    meta: {
      title: "",
    },
    component: () => import("../views/goGame.vue"),
  },
  {
    path: "/H5/doubleEleven",
    name: "doubleEleven",
    meta: {
      title: "狂欢双11",
    },
    component: () => import("../views/doubleEleven.vue"),
  },
  {
    path: "/H5/newElevenPay",
    name: "newElevenPay",
    meta: {
      title: "",
    },
    component: () => import("../views/newElevenPay.vue"),
  },
  {
    path: "/pay/pcPay",
    name: "pcPay",
    meta: {
      title: "支付",
    },
    component: () => import("../views/pcPay.vue"),
  },
  {
    path: "/pay/gameOrderPay",
    name: "gameOrderPay",
    meta: {
      title: "支付",
    },
    component: () => import("../views/gameOrderPay.vue"),
  },
  {
    path: "/H5/redirectTt",
    name: "redirectTt",
    meta: {
      title: "客服中转",
    },
    component: () => import("../views/redirectTt.vue"),
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from,) => {
  if (to.meta.title) {
    // 判断是否有标题
    document.title = to.meta.title;
  }
  // 跳转官网登录
  if (to.path == '/H5/charge' || to.path == '/H5/fuli' || to.path == '/H5/mine' || to.path == '/H5/turntable') {
    if (!localStorage.getItem('userTokens')) {
      if (to.query.appid) {
        localStorage.setItem("appid", to.query.appid);
      }
      if (to.query.os) {
        localStorage.setItem("os", to.query.os);
      }
      localStorage.setItem('path', to.path);
      window.location.href = '/H5/homeOpen';
    }
  }
  // 判断是否在微信浏览器，如果在重定向
  // if (to.path == '/H5' && isWechat() && to.query.os == 'microend') {
  //   window.location.href = window.location.origin + to.path + "?game_id=" + to.query.game_id + '&os=html5'
  //   // return
  // }

  // 跳转游戏登录页
  if (to.path == '/H5' && to.query.os == 'microend') {
    // localStorage.setItem('initUrl', window.location.href);
    localStorage.setItem("os", to.query.os);
    localStorage.setItem("gameid", to.query.game_id);
    window.location.href = `/H5/loginNew?os=${to.query.os}&gameid=${to.query.game_id}`;
  }
  if (to.name == 'getopenid') {
    if (!isWechat() && GetQueryString('os') != 'microend') {
      window.location.href = "https://www.fenyouwangluo.com/wxError.html";

    }
    // localStorage1.setItem('obj', JSON.stringify(GetUrlParam()))
  }
  if (to.name == 'getopenidVersion1') {
    if (!isWechat() && GetQueryString('os') != 'microend') {
      window.location.href = "https://www.fenyouwangluo.com/wxError.html";

    }
    // localStorage1.setItem('obj', JSON.stringify(GetUrlParam()))
  }
  // 判断支付页面有没有openid，没有则先授权在跳转
  if (to.name == 'payDetil') {
    if (!isWechat()) {
      window.location.href = "https://www.fenyouwangluo.com/wxError.html";
    }
    // else{
    //   if (!localStorage1.getItem('code')) {
    //     localStorage1.setItem('sdk_order_no', GetQueryString('sdk_order_no'));
    //     localStorage1.setItem('app_id', GetQueryString('app_id'));
    //     localStorage1.setItem('game_id', GetQueryString('game_id'));
    //     localStorage1.setItem('payUrl', 'payDetil');
    //     console.log(1111111111,window.location.origin + "/H5/")
    //     // window.location.href = window.location.origin + "/H5/#/";
    //     // window.location.href = window.location.origin
    //   }
    // }
  } else if (to.name == 'pay') {
    if (!isWechat()) {
      window.location.href = "https://www.fenyouwangluo.com/wxError.html";
    }
    // else{
    //   if (!localStorage1.getItem('code')) {
    //     localStorage1.setItem('app_id', GetQueryString('app_id'));
    //     localStorage1.setItem('game_id', GetQueryString('game_id'));
    //     localStorage1.setItem('payUrl', 'pay');
    //     window.location.href = window.location.origin + "/h5/";
    //     // window.location.href = window.location.origin
    //   }
    // }
  }

});
export default router;
